import React from "react";
import styles from "../CSS/PostCard.module.css";

const PostCard = ({ phoneNumber, postText, image }) => {
  return (
    <div className={styles.MainConatiner}>
      <section className={styles.Head}>
        <div className={styles.Left}>
          <img
            className={styles.UserPicture}
            src="https://cdn-icons-png.flaticon.com/128/1177/1177568.png"
            alt=""
          />
        </div>
        <div className={styles.Right}>
          <strong>{phoneNumber}</strong>
        </div>
      </section>
      <section className={styles.PostContent}>
        <p className={styles.PostText}>{postText}</p>
        <img src={image} alt="" className={styles.PSTIMage} />
        <div className={styles.IntrectionBox}>
          <button className={styles.IntrectionBTN}>
            <img
              src="https://cdn-icons-png.flaticon.com/128/3916/3916587.png"
              alt=""
            />
            Like
          </button>
          <button className={styles.IntrectionBTN}>
            <img
              src="https://cdn-icons-png.flaticon.com/128/5068/5068759.png"
              alt=""
            />
            Comment
          </button>
        </div>
      </section>
    </div>
  );
};

export default PostCard;
